'use client';

import ValueFacet from '@features/filter/components/Filters/ValueFacet';

import type { NumericHybridFacet } from '../../../types';
import InputFacet from '../InputFacet';

export default function NumericHybridFacet({ facet }: { facet: NumericHybridFacet }) {
  return (
    <>
      <ValueFacet facet={facet} />
      <InputFacet facet={facet} />
    </>
  );
}
